import React from "react";

const SubmitButton = ({ onClick, title = "Submit", disabled, isFormValid, loading, style }) => {

    return (
        <button
            disabled={disabled}
            type="button"
            style={{
                backgroundColor: isFormValid
                    ? "#aa8c97  "
                    : "#8F0D3d",
                cursor: disabled ? "not-allowed" : "pointer",
                // opacity: disabled ? 0.6 : 1,
                ...style
            }}
            className="add-button  f2 fs-xl-16 fs-xxl-18"
            onClick={onClick}
        >
            {loading ? (
                <>
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                    ></span>
                </>
            ) : (
                title
            )}
        </button>
    )
}
export default SubmitButton;
